/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React from 'react';
import PropTypes from 'prop-types';

import ActionButton from '../../atoms/ActionButton';
import * as S from './style';

const ActionButtonsPanel = ({
  children = null,
  cancelLabel = 'Cancel Label',
  confirmLabel = 'Save Changes Label',
  confirmAction = () => console.error('confirmAction not defined'),
  cancelAction = () => console.error('cancelAction not defined'),
  disabled = false,
  cancelDisabled = false,
  justifyContent = '',
}) => {
  return (
    <S.Container
      $justifyContent={justifyContent}
      data-testid="action-button-panel-container"
    >
      <ActionButton
        label={cancelLabel}
        onClick={cancelAction}
        secondary
        disabled={cancelDisabled}
        margin="0px"
      />
      {children}
      <ActionButton
        label={confirmLabel}
        disabled={disabled}
        onClick={confirmAction}
        minWidth="120px"
      />
    </S.Container>
  );
};

ActionButtonsPanel.propTypes = {
  children: PropTypes.node,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  confirmAction: PropTypes.func,
  cancelAction: PropTypes.func,
  disabled: PropTypes.bool,
  cancelDisabled: PropTypes.bool,
  justifyContent: PropTypes.string,
};

export default ActionButtonsPanel;
